// Okta Configuration
// Replace these values with your actual Okta application settings

const oktaConfig = {
  // Your Okta domain
  issuer:
    process.env.REACT_APP_OKTA_ISSUER ||
    'https://integrator-5341002.okta.com/oauth2/default',

  // Your Okta application's Client ID
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oaxne087tfRQPNln697',

  // The callback URL after successful login
  redirectUri:
    process.env.REACT_APP_OKTA_REDIRECT_URI ||
    window.location.origin + '/login/callback',

  // Post logout redirect URI
  postLogoutRedirectUri:
    process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI ||
    window.location.origin,

  // OAuth 2.0 scopes requested
  scopes: ['openid', 'profile', 'email', 'api.access', 'offline_access'],

  // Additional Okta configuration options
  pkce: true, // Enable PKCE for security

  // Disable HTTPS requirement for development (only if needed)
  devMode: process.env.NODE_ENV === 'development',

  // Token manager configuration
  tokenManager: {
    storage: 'localStorage',
    autoRenew: true,
    autoRemove: true,
    expireEarlySeconds: 30,
    storageKey: 'okta-token-storage',
  },

  cookies: {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'Lax',
  },

  // Transform auth state for easier use in components
  transformAuthState: (oktaAuth, authState) => {
    if (!authState) return authState;

    return {
      ...authState,
      user: authState.idToken ? authState.idToken.claims : null,
    };
  },
};

export default oktaConfig;
